var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEvaluationComplete = function SvgEvaluationComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#evaluation-complete_svg__a)",
    fill: "#1C7CE5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.847 12.072-10.12-10.12a6.68 6.68 0 0 0-9.434 0l-10.12 10.12A3.973 3.973 0 0 0 0 14.902V28a4.002 4.002 0 0 0 4.002 4.003h24.015A4.002 4.002 0 0 0 32.019 28V14.902a3.972 3.972 0 0 0-1.172-2.83ZM29.35 28a1.334 1.334 0 0 1-1.334 1.332H4.002A1.334 1.334 0 0 1 2.67 28V14.902c0-.353.141-.692.39-.942L13.18 3.843a4.014 4.014 0 0 1 5.662 0l10.12 10.12c.247.25.388.587.39.939V28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.087 13.383a1.252 1.252 0 0 1 0 1.769l-8.39 8.39a1.25 1.25 0 0 1-1.769 0l-3.994-3.994a1.25 1.25 0 0 1 1.768-1.768l3.11 3.111 7.504-7.504a1.25 1.25 0 0 1 1.77-.004Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "evaluation-complete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .002)",
    d: "M0 0h32.019v32H0z"
  })))));
};
export default SvgEvaluationComplete;